import { Component, ChangeDetectionStrategy } from '@angular/core';
import {
  TermsOfServiceTitle,
  TermsOfServiceTitleJsonKey,
  TermsOfServiceText,
  TermsOfServiceTextJsonKey,
} from 'src/app/constants/static-text';

@Component({
  selector: 'mwp-terms-of-service',
  templateUrl: './terms-of-service.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TermsOfServiceComponent {
  public termsOfServiceTitle: string = TermsOfServiceTitle;
  public termsOfServiceTilteJsonKey: string = TermsOfServiceTitleJsonKey;
  public termsOfServiceText: string = TermsOfServiceText;
  public termsOfServiceTextJsonKey: string = TermsOfServiceTextJsonKey;

  constructor() {}

  download() {
    window
      .open(
        'https://www.myworkplace.net/imagesclient/assets/MyWorkplaceTermsOfService.pdf',
        '_blank'
      )
      .focus();
  }
}
